import React from "react";
import { LIST_VIEW_COLUMNS, isSortable } from "types/sense";
import { useDispatch, useSelector } from "types/store";
import { getSortedDatasetIdList } from "containers/Sense/dataset-selectors";
import { getListSortAscending, getListSortColumn, updateGlobalState } from "containers/Sense/reducer";
import DatasetListItem from "@/components/Tiles/Sense/TableView/DatasetListItem";
import styles from "./style.module.css";
import { cn } from "@/utils/cn";
const DatasetList = () => {
    const dispatch = useDispatch();
    const listSortColumn = useSelector(getListSortColumn);
    const listSortAscending = useSelector(getListSortAscending);
    const sortedDatasetIds = useSelector(getSortedDatasetIdList);
    return (React.createElement("div", { className: styles.senseListHolder },
        React.createElement("table", { className: cn(styles.senseTable) },
            React.createElement("thead", null,
                React.createElement("tr", { style: { borderBottom: "1px solid #8e8e9c", backgroundColor: "#eeeff4" } }, LIST_VIEW_COLUMNS.map((c) => (React.createElement("th", { style: { cursor: isSortable(c) ? undefined : "pointer", padding: "5px 10px" }, key: c.value, onClick: !isSortable(c)
                        ? undefined
                        : () => {
                            if (listSortColumn === c.value) {
                                dispatch(updateGlobalState({
                                    listSortAscending: !listSortAscending
                                }));
                            }
                            else {
                                dispatch(updateGlobalState({
                                    listSortAscending: c.isAscending,
                                    listSortColumn: c.value
                                }));
                            }
                        } }, c.label))))),
            React.createElement("tbody", null, sortedDatasetIds.map((id) => (React.createElement(DatasetListItem, { key: id, datasetId: id })))))));
};
export default DatasetList;
